// src/components/ui/badge.jsx
import * as React from "react"
import { cn } from "@/lib/utils"

const badgeVariants = {
  variant: {
    success: "bg-green-500/10 border-green-500/20 text-green-400",
    warning: "bg-amber-500/10 border-amber-500/20 text-amber-400",
    error: "bg-red-500/10 border-red-500/20 text-red-400",
    info: "bg-blue-500/10 border-blue-500/20 text-blue-400",
    neutral: "bg-[#1a1a1a] border-[#2a2a2a] text-[#a0a0a0]",
  },
}

const Badge = React.forwardRef(
  ({ className, variant = "neutral", ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(
          "inline-flex items-center gap-1.5 px-2.5 py-1 border text-xs font-medium rounded-md",
          badgeVariants.variant[variant],
          className
        )}
        {...props}
      />
    )
  }
)
Badge.displayName = "Badge"

export { Badge, badgeVariants }